import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { API, DataStore, graphqlOperation } from 'aws-amplify';
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import { graphQLFindRecordById } from "../../helper/commonfunctions";
import { Column } from "primereact/column";

import ArchiveDialog from "./index"

// CheckboxHeader.js
import { Checkbox } from 'primereact/checkbox';

const CheckboxHeader = ({ data, selectedRows, setSelectedRows, getMasterData, setReportLoading, queries, tableName, mutations,loggedUserId , stipendApprover }) => {
  console.log("test")


  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [archiveVisible, setArchiveVisible] = useState(false);


  const loadReport = async () => {
    await getMasterData();
  }

  const handleButtonClick = () => {
    if (selectedRows.length) {
      // Toggle the panel state
      setIsPanelOpen(!isPanelOpen);
    }

    // You can perform additional actions here
    // For example, fetch data, update state, etc.
  };


  const getReportArchive = () => {
    console.log(selectedRows, "selectedRows")
    if (selectedRows.length) {
      setArchiveVisible(true);
    }
  };

  const handleSelectAll = (e) => {
    if (selectedRows.length === data.length) {
      // If all rows are already selected, clear the selection
      setSelectedRows([]);
    } else {
      //desig= I,AP,siteadmin, teacher, budclerk
      // rid:,userId:,budclerk:true
      // If not all rows are selected, select all rows
      const allRowIds = data.map((row) => 
      row.id);
      setSelectedRows(allRowIds);
    }
  };


  return (
    <>
      <Checkbox  onChange={handleSelectAll} checked={data?.length > 0 ? selectedRows.length === data.length : false} />
      <div className="p-checkbox relative inline-block">
        <button
          onClick={handleButtonClick}
          type="button"
          className="inline-flex items-center p-1  text-gray-400 hover:text-gray-600 focus:outline-none focus:ring focus:border-blue-300"
        >
          <div className="pi pi-ellipsis-v text-[#667085] cursor-pointer" tabIndex="0">
            {/* Vertical three dots */}
            {/* <div className="w-1 h-1 bg-gray-700 rounded-full"></div>
            <div className="w-1 h-1 bg-gray-700 rounded-full my-1"></div>
            <div className="w-1 h-1 bg-gray-700 rounded-full"></div> */}
          </div>
        </button>
      </div>



      {/* Panel */}
      {isPanelOpen && (
        <div className="origin-top-left absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          {/* Panel content goes here */}
          <div className="py-1">
            <a
              href="#"
              onClick={() => {
                getReportArchive()

              }}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Move to Archive
            </a>



            {/* Add more actions as needed */}
          </div>
        </div>
      )}


      {
        (archiveVisible) ?
          <ArchiveDialog
            archiveVisible={archiveVisible}
            setArchiveVisible={setArchiveVisible}
            setIsPanelOpen={setIsPanelOpen}
            selectedRows={selectedRows}
            getMasterData={() => { console.log("loader load"); loadReport() }}
            setIsLoadData={() => setReportLoading(true)}
            // queries={queries.getInitiateClassifiedWeeklyAbsenceReport}
            // tableName={"getInitiateClassifiedWeeklyAbsenceReport"}
            // mutations={mutations.updateInitiateClassifiedWeeklyAbsenceReport}
            setSelectedRows={setSelectedRows}
            queries={queries}
            tableName={tableName}
            mutations={mutations}
            archiveData={data}
            loggedUserId={loggedUserId}
            stipendApprover={stipendApprover}
          /> : null
      }

    </>

  );
};

export default CheckboxHeader;